import { comment } from "postcss";
import React, { useState } from "react";

const Comment = () => {
  const [commentState, setCommentState] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState(false);

  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  }

  const registerCommentHandler = async () => {
    setEmailError(false);

    let _response;

    if (name === "" || email === "" || commentState === "") {
      console.log("lengthh zaro");
      return;
    }

    if (validateEmail(email)) {
    } else {
      setEmailError(true);
      return;
    }
    setEmailError(false);

    try {
      _response = await fetch(
        `${process.env.REACT_APP_URL}/api/registerComment`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
          },
          body: JSON.stringify({
            secretKey: process.env.REACT_APP_SECRET_KEY,
            comment: commentState.trim(),
            name: name.trim(),
            email: email.trim(),
          }),
        }
      );
    } catch {
      return window.Notification.showError("عدم به روز رسانی سایت. ");
    }
    console.log(_response.status);
    setCommentState("");
    setName("");
    setEmail("");
    if (_response.ok) {
    }

    if (_response.status === 500) {
    }

    if (!_response.ok) {
    }
  };

  return (
    <div className=" m-10 w-[60%] mx-auto screen1000:w-[80%] screen600:w-[95%] ">
      <div className="text-right my-4 text-[#f6f439] screen600:mr-4">
        پیشنهادات وانتقادات
      </div>
      <div className="w-full mx-auto  rounded-2xl  bg-gray-400 p-10">
        <div style={{ direction: "rtl" }}>
          <input
            dir="rtl"
            placeholder="نام خود را وارد کنید"
            type="text"
            className=" w-[50%] rounded-lg px-2 py-2 focus:outline-none text-[12px] screen500:w-full screen450:text-[10px]"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div style={{ direction: "rtl" }} className="my-4">
          <input
            dir="rtl"
            type="email"
            placeholder="ایمیل خود را وارد کنید"
            className=" w-[50%] rounded-lg py-2 px-2 focus:outline-none text-[12px] screen500:w-full screen450:text-[10px]"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {emailError && (
            <small className="text-[11px] mr-1 text-red-600 font-bold">
              لطفا ایمیل خود را وارد کنید
            </small>
          )}
        </div>
        <div style={{ direction: "rtl" }} className="w-full mx-auto">
          <textarea
            rows="3"
            placeholder=" نظر شما ..."
            className="w-full mx-auto rounded-2xl p-2 outline-red-700 shadow-md shadow-[#5c5b5b] text-[12px] focus:outline-none screen450:text-[10px] "
            style={{ direction: "rtl" }}
            value={commentState}
            onChange={(e) => setCommentState(e.target.value)}
          />
        </div>
        <div className=" mt-6  w-40 screen500:mx-auto">
          <button
            // disabled={!name || !validateEmail(email) || !comment}
            disabled={!name || !email || !comment}
            className={`w-40 py-1 rounded-md bg-[#606161] text-[#f6f439] disabled:text-gray-200 disabled:cursor-not-allowed `}
            onClick={registerCommentHandler}
          >
            ثبت
          </button>
        </div>
      </div>
    </div>
  );
};

export default Comment;
